// Mock数据
export const mockData = {
  // 首页数据
  home: {
    banner: [
      {
        id: 1,
        title: '检查企业高新资质',
        subtitle: '聚焦高新技术企业认定材料与研发费用核查',
        image: require('@/assets/banners/banner1.png')
      },
      {
        id: 2,
        title: '品质铸就品牌',
        subtitle: '以专业检测能力与严谨流程守护服务品质',
        image: require('@/assets/banners/banner2.png')
      },
      {
        id: 3,
        title: '专业检测服务',
        subtitle: '覆盖食品 环境 药品 化妆品等多领域检测需求',
        image: require('@/assets/banners/banner3.png')
      },
      {
        id: 4,
        title: '技术驱动发展',
        subtitle: '依托专业团队与先进设备提供可靠数据支持',
        image: require('@/assets/banners/banner4.png')
      }
    ],
    advantages: [
       {
          id: 1,
          title: '权威资质认证',
          description: '获得CMA检验检测机构资质认定证书，拥有2000余项检验检测资质参数，可出具具有证明作用的数据和结果',
          icon: '🏆'
        },
        {
          id: 2,
          title: '专业技术团队',
          description: '现有员工90余人，其中博士6人、硕士4人、高级工程师7人、工程师15人，专业技术力量雄厚',
          icon: '👨‍🔬'
        },
        {
          id: 3,
          title: '先进检测设备',
          description: '拥有国内外先进检验检测仪器设备220余台，确保检测数据的准确性和可靠性',
          icon: '🔬'
        },
        {
          id: 4,
          title: '规模化实验室',
          description: '经营场所总面积5000余平方米，其中实验室4000余平方米，检测环境优越',
          icon: '🏢'
        },
        {
          id: 5,
          title: '广泛检测范围',
          description: '涵盖食品、食用农产品、药品、化妆品、环境、公共场所卫生、矿石煤炭等多领域检测服务',
          icon: '📋'
        },
        {
          id: 6,
          title: '一站式服务',
          description: '集检验检测、技术咨询和培训服务为一体，为客户提供全方位的专业技术支持',
          icon: '🤝'
        }
    ],
    coreBusiness: [
      {
        id: 1,
        title: '人工智能',
        description: '基于深度学习的智能解决方案',
        image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=artificial%20intelligence%20technology%20concept&image_size=square'
      },
      {
        id: 2,
        title: '物联网',
        description: '构建智能互联的物联网络',
        image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=internet%20of%20things%20concept&image_size=square'
      },
      {
        id: 3,
        title: '云计算',
        description: '提供高效稳定的云服务',
        image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=cloud%20computing%20technology&image_size=square'
      }
    ]
  },
  // 产品数据
  products: [
    {
      id: 1,
      name: '智能分析系统',
      description: '基于AI的数据分析平台，提供实时洞察',
      image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=intelligent%20analysis%20system%20dashboard&image_size=square',
      details: '智能分析系统是一款基于人工智能技术的数据分析平台，能够快速处理海量数据并提供实时洞察。该系统采用深度学习算法，能够自动识别数据中的模式和趋势，为企业决策提供科学依据。系统支持多种数据源接入，包括结构化和非结构化数据，可应用于金融、医疗、零售等多个行业。',
      parameters: [
        { name: '处理能力', value: '1000万条/秒' },
        { name: '准确率', value: '99.9%' },
        { name: '响应时间', value: '<100ms' },
        { name: '支持数据源', value: 'MySQL, PostgreSQL, MongoDB, Hadoop' },
        { name: '部署方式', value: '云端/本地' },
        { name: 'API接口', value: 'RESTful API' }
      ]
    },
    {
      id: 2,
      name: '物联网网关',
      description: '连接各类设备的智能网关',
      image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=iot%20gateway%20device&image_size=square',
      details: '物联网网关是连接各类智能设备的核心设备，能够实现设备之间的通信和数据传输。该网关支持多种通信协议，包括Wi-Fi、蓝牙、Zigbee、LoRa等，可连接数千个设备。网关内置边缘计算能力，能够在本地处理数据，减少云端传输压力，提高响应速度。',
      parameters: [
        { name: '支持协议', value: 'Wi-Fi, 蓝牙, Zigbee, LoRa' },
        { name: '最大连接设备数', value: '5000' },
        { name: '数据传输速率', value: '1Gbps' },
        { name: '工作温度', value: '-20℃ ~ 70℃' },
        { name: '电源', value: 'DC 12V' },
        { name: '防护等级', value: 'IP67' }
      ]
    },
    {
      id: 3,
      name: '云服务平台',
      description: '提供弹性计算和存储服务',
      image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=cloud%20service%20platform&image_size=square',
      details: '云服务平台提供弹性计算、存储和网络服务，帮助企业快速构建和部署应用。该平台采用分布式架构，具有高可用性和可扩展性，能够根据业务需求自动调整资源。平台支持多种云服务，包括虚拟机、容器、对象存储、数据库等，满足不同企业的需求。',
      parameters: [
        { name: '计算能力', value: '1-128核CPU' },
        { name: '内存', value: '1-1024GB' },
        { name: '存储容量', value: '1TB-1PB' },
        { name: '网络带宽', value: '1Gbps-100Gbps' },
        { name: '可用性', value: '99.99%' },
        { name: '支持语言', value: 'Java, Python, Node.js, Go' }
      ]
    }
  ],
  // 新闻数据
  news: [
    {
      id: 1,
      title: '公司获得A轮融资',
      content: '近日，公司成功获得A轮融资，将用于技术研发和市场拓展。',
      date: '2026-04-10',
      type: '公司动态',
      image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=business%20financing%20news&image_size=landscape_4_3'
    },
    {
      id: 2,
      title: '新产品发布会成功举办',
      content: '公司举办了2026年新产品发布会，推出了多款创新产品。',
      date: '2026-04-05',
      type: '公司动态',
      image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=product%20launch%20event&image_size=landscape_4_3'
    },
    {
      id: 3,
      title: '国务院发布关于促进数字经济发展的指导意见',
      content: '国务院近日发布关于促进数字经济发展的指导意见，提出了一系列支持政策。',
      date: '2026-04-01',
      type: '政务新闻',
      image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=government%20news%20conference&image_size=landscape_4_3'
    },
    {
      id: 4,
      title: '关于2026年五一假期安排的通知',
      content: '公司发布2026年五一假期安排通知，具体放假时间为5月1日至5月5日。',
      date: '2026-03-20',
      type: '通知公告',
      image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=company%20announcement%20notice&image_size=landscape_4_3'
    },
    {
      id: 5,
      title: '企业资质办理指南',
      content: '详细介绍企业资质办理的流程和所需材料，帮助企业快速完成资质申请。',
      date: '2026-03-15',
      type: '办事指南',
      image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=business%20guidance%20document&image_size=landscape_4_3'
    },
    {
      id: 6,
      title: '2026年最新网络安全法规解读',
      content: '对2026年最新出台的网络安全法规进行详细解读，帮助企业合规运营。',
      date: '2026-03-10',
      type: '政策法规',
      image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=legal%20document%20analysis&image_size=landscape_4_3'
    }
  ],
  // 资料下载数据
  downloads: [
    {
      id: 1,
      title: '产品白皮书',
      description: '详细介绍公司产品的技术特点和应用场景',
      fileUrl: '#',
      size: '2.5MB',
      format: 'PDF',
      category: '产品资料'
    },
    {
      id: 2,
      title: '解决方案手册',
      description: '针对不同行业的解决方案指南',
      fileUrl: '#',
      size: '1.8MB',
      format: 'PDF',
      category: '解决方案'
    },
    {
      id: 3,
      title: '技术架构文档',
      description: '公司产品的技术架构设计和实现方案',
      fileUrl: '#',
      size: '3.2MB',
      format: 'PDF',
      category: '技术资料'
    },
    {
      id: 4,
      title: 'API接口文档',
      description: '详细的API接口说明和使用示例',
      fileUrl: '#',
      size: '1.5MB',
      format: 'PDF',
      category: '技术资料'
    },
    {
      id: 5,
      title: '行业研究报告',
      description: '2026年行业发展趋势分析报告',
      fileUrl: '#',
      size: '4.7MB',
      format: 'PDF',
      category: '市场资料'
    },
    {
      id: 6,
      title: '用户操作指南',
      description: '产品使用操作详细指南',
      fileUrl: '#',
      size: '2.1MB',
      format: 'PDF',
      category: '产品资料'
    }
  ],
  // 关于我们数据
  about: {
    companyInfo: {
      name: '遵义市精科信检测有限公司',
      description: '遵义市精科信检测有限公司是一家主要从事食品、食用农产品、药品、化妆品、环境、公共场所卫生、矿石煤炭等检验检测、技术咨询和培训服务为一体的专业第三方检验检测机构。成立于2016年12月1日，注册资本2500万元，位于遵义市播州区芶江镇贵州苟江经济开发区。2017年9月19日获得《检验检测机构资质认定证书》（CMA证书），证书编号：172400340756，可以向社会出具具有证明作用的数据和结果。现已获得检验检测资质参数2000余项。公司经营场所总面积5000余平方米，其中实验室4000余平方米。拥有国内外先进检验检测仪器设备220余台。现有员工90余人，其中博士6人、硕士4人、高级工程师7人、工程师15人。',
      mission: '提供专业、准确、公正的检验检测服务，保障食品安全和环境健康',
      vision: '成为西南地区领先的第三方检验检测机构',
      values: '专业、诚信、公正、创新',
      image: require('@/assets/news_banner2.png')
    },
    timeline: [
      {
        id: 1,
        date: '2016年12月1日',
        title: '公司成立',
        description: '遵义市精科信检测有限公司正式成立，注册资本2500万元，位于遵义市播州区芶江镇贵州苟江经济开发区'
      },
      {
        id: 2,
        date: '2017年9月19日',
        title: '获得CMA证书',
        description: '获得《检验检测机构资质认定证书》（CMA证书），证书编号：172400340756，可以向社会出具具有证明作用的数据和结果'
      },
      {
        id: 3,
        date: '2018年',
        title: '业务拓展',
        description: '科技服务已遍布全省各地区，承担了县区级食品、食用农产品、药品、化妆品抽检等项目'
      },
      {
        id: 4,
        date: '2019年',
        title: '获得高新技术企业认证',
        description: '被认定为国家高新技术企业，技术实力得到官方认可'
      },
      {
        id: 5,
        date: '2020年',
        title: '建立院士专家工作分站',
        description: '建立了"中国农业科学院-遵义市播州区院士专家工作分站"'
      },
      {
        id: 6,
        date: '2021年',
        title: '承担科技项目',
        description: '承担了"遵义市农产品药品检验检测工程技术研究中心"、"贵州省大型科研仪器共享服务机构"等科技项目'
      },
      {
        id: 7,
        date: '2022年',
        title: '获得专利授权',
        description: '获得发明专利3件，实用新型专利10件，注册商标3件，著作权2件'
      },
      {
        id: 8,
        date: '2023年',
        title: '资质扩展',
        description: '已获得检验检测资质参数2000余项，服务能力进一步提升'
      }
    ],
    team: [
      {
        id: 1,
        name: '张总',
        position: '创始人兼CEO',
        description: '拥有多年检验检测行业经验，致力于打造专业的第三方检验检测机构，推动行业健康发展。',
        avatar: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=professional%20businessman%20portrait&image_size=square'
      },
      {
        id: 2,
        name: '李总',
        position: '技术总监',
        description: '博士学位，高级工程师，拥有丰富的检验检测技术经验，负责公司技术研发和实验室管理。',
        avatar: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=professional%20female%20tech%20leader%20portrait&image_size=square'
      },
      {
        id: 3,
        name: '王总',
        position: '质量总监',
        description: '硕士学位，工程师，负责公司质量管理体系建设和运行，确保检测数据的准确性和可靠性。',
        avatar: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=professional%20business%20leader%20portrait&image_size=square'
      },
      {
        id: 4,
        name: '赵总',
        position: '实验室主任',
        description: '博士学位，高级工程师，负责实验室日常管理和技术指导，确保实验室规范运行。',
        avatar: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=professional%20tech%20director%20portrait&image_size=square'
      },
      {
        id: 5,
        name: '刘总',
        position: '市场总监',
        description: '负责公司市场拓展和客户服务，建立了完善的市场服务体系。',
        avatar: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=professional%20marketing%20director%20portrait&image_size=square'
      },
      {
        id: 6,
        name: '陈总',
        position: '行政总监',
        description: '负责公司行政、人力资源和财务管理，为公司运营提供有力支持。',
        avatar: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=professional%20administrative%20director%20portrait&image_size=square'
      }
    ]
  }
}

// 模拟API延迟
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms))

// Mock API方法
export const mockApi = {
  // 获取首页数据
  async getHomeData() {
    await delay(300)
    return {
      code: 200,
      data: mockData.home,
      message: 'success'
    }
  },
  // 获取产品列表
  async getProducts() {
    await delay(300)
    return {
      code: 200,
      data: mockData.products,
      message: 'success'
    }
  },
  // 获取新闻列表
  async getNews() {
    await delay(300)
    return {
      code: 200,
      data: mockData.news,
      message: 'success'
    }
  },
  // 获取资料下载列表
  async getDownloads() {
    await delay(300)
    return {
      code: 200,
      data: mockData.downloads,
      message: 'success'
    }
  },
  // 获取关于我们数据
  async getAboutData() {
    await delay(300)
    return {
      code: 200,
      data: mockData.about,
      message: 'success'
    }
  },
  // 获取产品详情
  async getProductDetail(id) {
    await delay(300)
    const product = mockData.products.find(p => p.id === parseInt(id))
    return {
      code: 200,
      data: product,
      message: 'success'
    }
  },
  // 根据分类获取产品列表
  async getProductsByCategory(catId) {
    await delay(300)
    // 模拟根据分类返回不同的产品数据
    const products = [
      {
        id: 1,
        name: `检测服务示例1-${catId}`,
        description: '这是检测服务的描述信息',
        image: require('@/assets/banner.png')
      },
      {
        id: 2,
        name: `检测服务示例2-${catId}`,
        description: '这是检测服务的描述信息',
        image: require('@/assets/banner.png')
      },
      {
        id: 3,
        name: `检测服务示例3-${catId}`,
        description: '这是检测服务的描述信息',
        image: require('@/assets/banner.png')
      }
    ]
    return {
      code: 200,
      data: products,
      message: 'success'
    }
  }
}
